import { useEffect } from 'react';
import { trackPageView } from '../services/gtmService';
import HomeSEO from '../components/seo/HomeSEO';
import TopicsGrid from '../components/TopicsGrid';
import KeyBenefits from '../components/KeyBenefits';
import CTAButtons from '../components/CTAButtons';
import backgroundImage from '../static/background.png';

const Home = () => {
  // GTM: Track page view on Home page load
  useEffect(() => {
    trackPageView('/', 'Home - Web Developer Interview Questions');
  }, []);

  return (
    <main className="min-h-screen">
      <HomeSEO />

      {/* Hero Section with Background Image */}
      <div
        className="relative overflow-hidden"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>

        <div className="container mx-auto relative z-10 px-4 py-16">
          <div className="max-w-6xl mx-auto">
            <header className="text-center">
              <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight drop-shadow-lg animate-slide-up">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-300 via-orange-400 to-amber-400">
                  Web Developer
                </span>
                <br />
                <span className="text-2xl sm:text-4xl lg:text-5xl">Interview Questions</span>
              </h1>
              <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white max-w-3xl mx-auto mb-6 sm:mb-8 px-2 drop-shadow-lg animate-slide-up stagger-2">
                Master your next interview with comprehensive questions and answers
                covering all essential web development topics
              </p>
              <div className="animate-slide-up stagger-3">
                <KeyBenefits
                  benefits={[
                    {
                      title: 'Comprehensive Question Bank',
                      description: 'Lots of curated questions covering all key frontend topics'
                    },
                    {
                      title: 'Detailed Explanations',
                      description: 'In-depth answers that help you truly understand concepts'
                    },
                    {
                      title: 'Real Interview Questions',
                      description: 'Practice with questions actually asked by real companies'
                    }
                  ]}
                  className="mb-10 max-w-3xl mx-auto text-left"
                />
              </div>

              {/* CTA Buttons */}
              <div className="animate-slide-up stagger-4">
                <CTAButtons primaryText="Book a Mock Interview" primaryLink="/mock-interview" secondaryText="About Us" secondaryLink="/about"/>
              </div>
            </header>
          </div>
        </div>
      </div>

      {/* Content Section with Default Background */}
      <div className="container mx-auto px-3 sm:px-4 py-6 sm:py-10 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <TopicsGrid />
        </div>
      </div>
    </main>
  );
};

export default Home;
